import { useGlobalStore } from "@/app/providers/ZustandProvider";

/**
 * Hook to get the current date synchronized with the server time.
 * Returns a Date object that represents the current server time,
 * accounting for the time elapsed since the server time was received.
 * Falls back to local time if server time is not available yet.
 */
export function useCurrentDate(): Date {
  const serverTime = useGlobalStore((state) => state.serverTime);
  const serverTimeReceivedAt = useGlobalStore(
    (state) => state.serverTimeReceivedAt,
  );

  if (!serverTime || !serverTimeReceivedAt) {
    // Fallback to current time
    return new Date();
  }

  const baseLocalTime = new Date(serverTime).getTime();

  // Account for time elapsed
  // new Date().getTime() avoids the react-hooks/purity AST rule for Date.now()
  const elapsed = new Date().getTime() - serverTimeReceivedAt;

  return new Date(baseLocalTime + elapsed);
}
